<template>
  <component :is="loader" />
</template>
<script>
// Utils
import { mapGetters } from 'vuex'

// Components
import basic1 from './basic1'
import TaskTrack from '../task/Track'

export default {
  components: {
    basic1,
    TaskTrack
  },
  computed: {
    ...mapGetters(['wsCustom']),
    loader() {
      let _component = null
      if (this.wsCustom && this.wsCustom.template) {
        _component = this.wsCustom.template
      } else {
        _component = TaskTrack
      }
      return _component
    }
  }
}
</script>
